import { Datos } from './Datos';

export class DatosEnviar {
    CodigoPrimario: string | null;
    CodigoSecundario: string | null;
    Ejercicio: number;
    Mes: string;
    Datos: Datos[];
}


// WEBPACK FOOTER //
// ./src/app/models/DatosEnviar.ts